import ConsegnatiTable from "./consegnati-table/ConsegnatiTable";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import * as actions from "../../../../../../../../../store";

const ConsegnatiStep = (props) => {
    const tableLoading = useSelector(state => state.contrattoDigitaleReducer.deviceDetailsConsegnati.loading)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(actions.getDeviceDetailsDataConsgnati(props.commercialLabel, props.orderId))
    }, [dispatch, props.commercialLabel, props.orderId])

    return (
        <ConsegnatiTable loading={tableLoading}/>
    )
}

export default ConsegnatiStep